<template>
  <div id="app">

    <!-- <keep-alive> -->
    <router-view :key="$route.fullPath" />
    <!-- </keep-alive> -->
   
  </div>
</template>
<script>
    // "build:prod": "vue-cli-service serve --mode production",
// import { pageModuleseo } from '@/api/index'
export default {
  name: 'HomeView',
  data() {
    return {
    
    }
  },
 
  computed: {},
  mounted() {},
  created() {},

  methods: {

  }
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  // color: #2c3e50;
  min-height: calc(100vh - 50px);
  position: relative;
}
* {
  box-sizing: border-box;
  margin: 0;
}
</style>
